import axios from 'axios'

export const getTotalProjectByUser = (params) => {
  return axios.get(`count-project`, { params: params })
}



// WEBPACK FOOTER //
// ./src/api/system.js